<template>
    <svg
        :class="$options.name"
        viewBox="0 0 72 72"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
        >
            <g
                transform="translate(1.000000, 1.000000)"
                :stroke="color"
            >
                <circle
                    stroke-width="2"
                    cx="35"
                    cy="35"
                    r="35"
                ></circle>
                <path
                    d="M45.6325428,5.92061569 C42.3163098,4.67799584 38.7353056,4 35,4 C17.8791728,4 4,18.243747 4,35.8142993 C4,53.3848517 17.8791728,66 35,66 C52.1208272,66 66,53.3848517 66,35.8142993 C66,30.4041819 64.6841507,25.3094705 62.3629827,20.8488524 C61.1739615,18.5638954 59.7211435,16.4453254 58.0462685,14.5359788 M55.6015825,12.0412981 C53.9764723,10.556961 52.1981507,9.24548362 50.2940097,8.13497725"
                ></path>
                <polyline
                    :fill="color"
                    points="18.5708008 24.2233887 18.5708008 33.2435303 18.5708008 34.0168457 35 49.7435303 51.8684082 33.2435303 51.8684082 24.2233887 35.2196045 40.1022949 18.5708008 23.8730469"
                ></polyline>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'scroll-down',
    props: ['color']
}
</script>
<style lang="scss" scoped>
.scroll-down {
    width: 100%;
}
</style>
